export default {
  "index-page": () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/layouts/IndexPage.vue").then(m => m.default || m),
  default: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/layouts/default.vue").then(m => m.default || m),
  "fsf-desktop": () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/layouts/fsf/desktop.vue").then(m => m.default || m),
  fsf: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/layouts/fsf/index.vue").then(m => m.default || m),
  "fsf-mobile": () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/layouts/fsf/mobile.vue").then(m => m.default || m)
}